import type { SilobagExtractionListItem } from '@siloreal:shared:api/service/silobag/silobag-extraction-list';

export async function downloadSilobagExtractionReport(
  rows: readonly SilobagExtractionListItem[],
  fileName: string
): Promise<number> {
  if (rows.length === 0) {
    throw new Error('No hay extracciones para exportar.');
  }

  const { generateSilobagExtractionExcelData } = await import(
    '@siloreal:shared:sdk/excel/silobag-extraction-excel-generator'
  );

  await generateSilobagExtractionExcelData(rows, fileName);

  return rows.length;
}
